// ChipList/normalizer.ts
import { IChipListV4 } from '@nocode/types';

export const normalizeToV4 = (attrs: any): IChipListV4 => {
  // Already V4 shape — has nested title.style
  if (attrs.style.tag !== undefined) {
    return attrs;
  }

  // 0.4.2
  // Old flat shape — remap to V4
  // Chip-level styles (backgroundColor, border*, shadow, selectedColor) are
  // now stored in style.tag at the component level, not in attributes.
  let {
    backgroundColor: _backgroundColor,
    borderColor: _borderColor,
    borderStyle: _borderStyle,
    borderWidth: _borderWidth,
    borderRadius: _borderRadius,
    selectedColor: _selectedColor,
    shadow,
    selectedFontColor,
    selectedColor,
    fontFamily: _fontFamily,
    fontSize: _fontSize,
    color: _color,
    fontWeight: _fontWeight,
    iconColor,
    cardCover,
    itemSize,
    ...restAttributes
  } = attrs.attributes;

  // 4.0.0
  let {
    // tag
    backgroundColor,
    borderColor,
    borderStyle,
    borderWidth,
    borderRadius,
    //text
    fontFamily,
    fontSize,
    color,
    fontWeight,
    ...restStyle
  } = attrs.style;

  return {
    ...attrs,
    libraryVersion: '4.1.0',
    attributes: {
      ...restAttributes,
      title: {
        ...restAttributes.title,
        style: {
          fontFamily,
          fontSize,
          color,
          fontWeight,
          selected: {
            color: selectedFontColor,
          },
        },
      },
      closeIcon: {
        ...restAttributes.closeIcon,
        style: {
          iconColor,
        },
      },
      cardCover: cardCover
        ? {
            enabled: cardCover.enabled,
            imageType: cardCover.imageType,
            imagePlaceholder: cardCover.imagePlaceholder,
            imageUrl: cardCover.imageUrl,
            hasPlaceholder: cardCover.hasPlaceholder,
            image: cardCover.image,
            style: {
              borderColor: cardCover.borderColor,
              borderStyle: cardCover.borderStyle,
              borderWidth: cardCover.borderWidth,
              borderRadius: cardCover.borderRadius,
            },
          }
        : cardCover,
    },
    style: {
      ...restStyle,
      tag: {
        backgroundColor: backgroundColor ?? _backgroundColor,
        borderColor: borderColor ?? _borderColor,
        borderStyle: borderStyle ?? _borderStyle,
        borderWidth: borderWidth ?? _borderWidth,
        borderRadius: borderRadius ?? _borderRadius,
        height: itemSize,
        selected: {
          backgroundColor: selectedColor,
        },
        shadow,
      },
    },
  };
};
